/**
 * Builds a fetch response handler that will log user out, run callback and throw response upon 401
 *
 * @param {Function} callback
 *
 * @return {Function}
 */
export default function handleUnauth(callback) {
  return response => {
    if (response.status === 401) {
      callback(response);

      throw response;
    }

    return response;
  };
}
